// API configuration for different environments
const API_URL = (process.env.NODE_ENV === 'production' 
  ? process.env.REACT_APP_API_URL || 'https://qresto-app-backend.onrender.com' 
  : 'https://localhost:5000'
).replace(/\/+$/, ''); // Remove trailing slashes

export default API_URL;